// Where each lot type's pages live and which i18n key holds its code prefix
// (HERD/REBANHO, REPRO, WEIGHT/PESO) — for pages that list lots of mixed
// types, like a finance project's Lots section.
export const LOT_TYPES = {
  herd:         { basePath: '/herd/lots',         prefixKey: 'herd_lot_prefix' },
  reproduction: { basePath: '/reproduction/lots', prefixKey: 'lot_prefix' },
  weight:       { basePath: '/weight/lots',       prefixKey: 'weight_lot_prefix' },
};

export const lotPath = (lot) => `${(LOT_TYPES[lot.type] || LOT_TYPES.herd).basePath}/${lot.lot_id}`;

export const lotPrefixKey = (lot) => (LOT_TYPES[lot.type] || LOT_TYPES.herd).prefixKey;
